<template>
  <div>
    <v-server-table
      ref="CandidatesTable"
      v-if="dataReady"
      id="select-record-table"
      :key="wherethedatais"
      :columns="columns"
      :url="wherethedatais"
      :options="options"
      @loaded="getCount"
    >
      <!-- TITLE COLUMN -->
      <template v-slot:title="{ row }">
        <div class="table-header">{{ row.title | capitalize }}</div>
        <div class="mb-1">
          <div
            v-for="metadata in getMetadata(row,'title')"
            :key="metadata"
            class="table-meta mb-2"
          >
            {{ metadata }}
          </div>
        </div>
      </template>

      <!-- ARTIST COLUMN -->
      <template v-slot:artist="{ row }">
        <div class="table-header">{{ row.artist | capitalize }}</div>
        <div class="mb-1">
          <div
            v-for="metadata in getMetadata(row,'artist')"
            :key="metadata"
            class="table-meta mb-2"
          >
            {{ metadata }}
          </div>
        </div>
      </template>

      <!-- ISRC COLUMN -->
      <template v-slot:isrc="{ row }">
        <span class="medium">{{ row.isrc | upper }}</span>
      </template>

      <!-- DURATION COLUMN-->
      <template v-slot:duration="{ row }">
        {{ row.duration | normalizeSeconds }}
      </template>

      <!--TYPE COLUMN-->
      <template v-slot:type="{ row }">
        {{ row.type }}
      </template>

      <!-- COUNTRY OF RECORDING COLUMN-->
      <template v-slot:fixation_country="{ row }">
        {{ row.fixation_country | get("name") }}
      </template>

      <!-- LANGUAGE OF PERF COLUMN-->
      <template v-slot:lang_of_perf="{ row }">
        {{ getMetadata(row,'lang_of_perf')[0] }}
      </template>

      <!-- RIGHT OWNERS COLUMN -->
      <template v-slot:rightOwners="{ row }">
        {{ row.right_owners.join(', ') }}
      </template>

      <!-- RELEASE NAMES COLUMN-->
      <template v-slot:releaseNames="{ row }">
        <ReleaseNames
          classNames="table-meta mb-2"
          :releases="getMetadata(row,'release')"
        />
      </template>

      <!-- ELIGIBILITY-->
      <template v-slot:isEligible="{ row }">
        <i :class="row.eligible ? 'fas fa-check-circle active_state' : 'fas fa-times-circle blocked_state'" />
      </template>

      <!-- ACTIONS -->
      <template v-slot:actions="{ row }">
        <button
          class="button"
          @click="selectMatch(row.id)"
        >
          {{ $t('select')|capitalize }}
        </button>
      </template>
    </v-server-table>
  </div>
</template>

<script>
import {
  doRequest,
  isDefinedString,
  responsePaginatedAdapter
} from "@/assets/libs/utils"
import { mapGetters, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import { capitalize } from "lodash"

export default {
  name: "SelectRecordTable",
  computed: {
    ...mapState("soundsys", ["dataReady"]),
    ...mapGetters("soundsys", ["srTypes"]),

    wherethedatais () {
      const candidatesUrl = this.type === "usages" ? "soundrecordingusages" : "landingsoundrecordings"

      if (isDefinedString(this.search_text)) {
        return `/soundrecordings/?fuzzy_search=${
          this.search_text
        }`
      } else {
        return `/${candidatesUrl}/${this.id}/candidates/`
      }
    }
  },
  props: {
    id: {
      required: true
    },
    search_text: {
      required: false
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      count:0,
      columns: [
        "title",
        "artist",
        "isrc",
        "duration",
        "type",
        "fixation_country",
        "lang_of_perf",
        "fixation_year",
        "releaseNames",
        "rightOwners",
        "isEligible",
        "actions"
      ],
      options: {
        skin: "table table-striped",
        sortable: [],
        headings: {
          title: capitalize(this.$t("title")),
          artist: capitalize(this.$t("artist")),
          isrc: capitalize(this.$t("isrc")),
          duration: capitalize(this.$t("duration")),
          type: capitalize(this.$t("type")),
          fixation_country: capitalize(this.$t("fixation_country")),
          releaseNames: capitalize(this.$t("releaseNames")),
          rightOwners: capitalize(this.$t("rightOwners")),
          fixation_year: capitalize(this.$t("fixation_year")),
          isEligible: capitalize(this.$t("isEligible")),
          lang_of_perf: capitalize(this.$t("lang_of_perf")),
          actions: "",
        },
        columnsClasses: {
          title: "width-medium",
          artist: "width-medium",
          isrc: "width-medium",
          duration: "width-small",
          type: "width-small",
          fixation_country: "width-small",
          fixation_year: "width-small",
          rightOwners: "width-medium",
          releaseNames: "width-medium",
          lang_of_perf: "width-small",
          isEligible: "width-medium",
          actions: "width-small"
        },
        requestFunction (data) {
          return doRequest(this.url, { page_size:10, page:data.page })
        },
        responseAdapter: resp => {
          const response = responsePaginatedAdapter(resp)
          this.count = response.count
          return response
        }
      }
    }
  },
  beforeDestroy () {
    this.$emit("closing")
  },

  methods: {
    getMetadata ({ extras }, tag) {
      if (extras) {
        return extras.reduce((current, next) => {
          if (next.tag === tag) {
            current.push(next.value)
          }
          return current
        }, [])
      }
      return []
    },
    selectMatch (svId) {
      ApiCalls.selectMatch(this.id, svId, this.type)
        .then(() => {
          this.$toasted.global.toast(this.$t("manually_matched"))
          this.$emit("selectedSuccess")
        })
        .catch(err => {
          this.$emit("selectedSuccess")
          this.$toasted.global.toast(err)
        })
    },
    getCount () {
      if(isDefinedString(this.search_text)){
        this.$refs.CandidatesTable.$refs.table.count = this.count
        return
      }
      this.count = 0
      this.$refs.CandidatesTable.$refs.table.count = this.count
    },
  }
}
</script>
